<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  [thick]="true"
  color="#1C84EE"
  [ease]="'linear'"
></ng-progress>
<router-outlet></router-outlet>
